// @flow

import { fetchCart } from 'client/actions/cart';
import { fetchUser } from 'client/actions/user';
import { receiveTranslations } from 'client/actions/translations';
import { renderAll } from 'client/utils/render';
import CookieBanner from 'client/components/banner/CookieBanner';
import CountdownTimer from 'client/components/countdownTimer';
import EmailOrHealthEntry from 'client/components/emailOrHealthEntry';
import HealthEntryPoint from 'client/components/ifpApp/healthEntryPoint';
import HomeNav from 'client/components/homeNav/homeNavContainer';
import MobileLoginLogoutBtn from 'client/components/homeNav/mobileLoginLogoutBtnContainer';
import PreRegistration from 'client/components/preRegistration/preRegistrationContainer';
import HomeHealthHero from 'routes/home/components/homeHealthHeroContainer';
import { ExtoleReferralSimpleButtonCard } from 'client/components/extole/extoleReferralSimpleButtonCard';

import commonJson from 'translations/stride/en-US/common.json';
import purchaseJson from 'translations/stride/en-US/purchase.json';
import taxesJson from 'translations/stride/en-US/taxes.json';

import 'client/styles/common.scss';

import * as rootReducer from './reducers';
import { BASE_NAME } from './base';
import configureStore from '../configureStore';
import FullFooter from '../../client/components/footer/full';
import Faq from './components/faq';
import './styles/home.scss';

const store = configureStore(rootReducer, {
  client: true,
  // eslint-disable-next-line no-underscore-dangle
  initialData: window.__INITIAL_STATE__,
});

const dispatchStore = async () => {
  await store.dispatch(receiveTranslations(commonJson, 'common'));
  await store.dispatch(receiveTranslations(purchaseJson, 'purchase'));
  await store.dispatch(receiveTranslations(taxesJson, 'taxes'));

  await store.dispatch(fetchUser());
  await store.dispatch(fetchCart());
};

const components = {
  CookieBanner,
  CountdownTimer,
  EmailOrHealthEntry,
  FullFooter,
  HealthEntryPoint,
  HomeHealthHero,
  HomeNav,
  MobileLoginLogoutBtn,
  PreRegistration,
  ExtoleReferralSimpleButtonCard,
  Faq,
};

dispatchStore()
  .then(() => renderAll(components, store))
  .catch(err => console.log(err)); // eslint-disable-line no-console

export const bundleName = BASE_NAME;
